import {
    getList,
    getItem,
    putItem,
    postItem,
} from "./utils/entity-network-requests"

const entityName = "moderation_feed"

export const getModerationList = (token, parameters) =>
    getList(entityName, parameters, token)
export const getModerationItem = (token, id) => getItem(entityName, id, token)
export const putModerationItem = (token, id, knowledge) =>
    putItem(entityName, id, knowledge, token)

export function postModerationItem(
    token,
    data,
    dataType,
    shouldPersist,
    isSimple,
) {
    const dataToAnalyse = {
        [dataType]: data,
        persist: shouldPersist,
        simple: isSimple,
    }
    return postItem(`${entityName}?api_version=2`, dataToAnalyse, token)
}

export const getModerationItemStatus = (token, id) =>
    getItem(entityName, `status/${id}`, token)

export const getModerationItemFulltext = (token, id) =>
    getItem(entityName, `${id}/fulltext`, token).map(data => ({ id, ...data}))
